import './PreviewBlock.scss';

import React, { FunctionComponent } from 'react';

import classNames from 'classnames';

type PreviewBlockProps = {
  isActive?: boolean;
  isDarkBackground?: boolean;
  isLarge?: boolean;
  children: React.ReactNode;
};

const PreviewBlock: FunctionComponent<PreviewBlockProps> = ({
  isActive,
  isDarkBackground,
  isLarge,
  children,
}) => {
  if (!isActive) return <>{children}</>;
  return (
    <div
      className={classNames({
        'preview-block': true,
        'preview-block__dark': isDarkBackground,
        'preview-block__large': isLarge,
      })}
      aria-hidden
    >
      <span className="preview-block__children">{children}</span>
    </div>
  );
};

export default PreviewBlock;
